module.exports = __webpack_public_path__ + "img/151.7d248c6f.jpg";